import React, {Component} from 'react';
import $ from 'jquery';
import 'jquery-validation';
import {getPeopleBySkills} from '../../util/APIUtils';
import {Field, reduxForm} from 'redux-form';
import {Provider} from "react-redux";
import Store from '../../helpers/Store';
import {inputField} from '../../helpers/Error';
import moment from 'moment';
import CreatableSelect from "react-select/lib/Creatable";

import {
       JOB_PRIORITY_LOW,JOB_PRIORITY_MEDIUM,JOB_PRIORITY_HIGH,
       JOB_STATUS_SCHEDULED,JOB_STATUS_UNSCHEDULED,JOB_STATUS_WORKING,JOB_STATUS_CLOSED
       } from '../../constants';
import './JobScheduleForm.css';
import 'datepair.js';


const validate = (values, props) => {
    const errors = {};
    return errors;
};

class modelForm extends React.Component {


    constructor(props) {
        super(props);
        //console.log('selected people', this.props.states);
        //console.log(this.props.initialValues);
        this.state = {
            loading: true,
            skills: [],
            people: []
        };
          this.callSkill = this.callSkill.bind(this);

    }

    onSelectSkillChange(value) {
        const target = value;
        this.setState({skills: target});
        let option = JSON.stringify(target);
        if(target.length == 0){
            option = '';
        }
        $('#selectedSkill').val(option);


        if(target.length>0){
            var skillarray = [];
            var fields={};
            for(var k in value){
                     skillarray.push(value[k].value);
            }
            fields['skills'] = skillarray;
            console.log(fields);
           // this.callSkill(fields);
           // return false;
               
        }
    }

    callSkill(fields){
         if(fields){
                getPeopleBySkills(fields)
                .then(response => {
                     console.log(response);
                }).catch(error => {
                    console.log("error in getPeopleBySkills");
                }); 
            }
    }

    onSelectPeopleChange(value){
        const people = value;
        this.setState({people: people});
        $('#selectedPeoples').val(JSON.stringify(people));
    }

    componentDidMount() {
        var $this = this;
        $('#add-new-event').on('shown.bs.modal', function (e) {
            //let $this = $(this);
            //var selectedSkill = $(this).find('#selectedSkill').val();
           // $this.setState({skills: (selectedSkill !== '') ? JSON.parse(selectedSkill) : []});

           // var selectedPeoples = $(this).find('#selectedPeoples').val();
           // $this.setState({people: (selectedPeoples !== '') ? JSON.parse(selectedPeoples) : []});
        });
        $('#add-new-event').on('hidden.bs.modal', function (e) {
            $('#selectedSkill').val('');
            $('#selectedPeoples').val('');
            $this.setState({skills: [], people: []});
        });
    }

    render() {
        //console.log('this.state.skills', this.state.skills);
        return (
            <form name="jobscheduleform" id="jobscheduleform">
                   
                    <input type="hidden" id="id"/>
                     
                    <div className="row">
                        <div className="col-lg-12">


                            <div id="basicExample" className="form-group1" >
                                <div >
                                    <label className="control-label">Job Start Time</label>
                                    <div>
                                        <input type="text" id="fromdate" name="fromdate" placeholder="MM/DD/YYYY" className="form-control date start" style={{width: '53%'}}  /> &nbsp;&nbsp;&nbsp;
                                        <input type="text" id="fromtime" name="fromtime" placeholder="00:00 AM/PM" className="form-control time start" style={{width: '42%'}}   autoComplete="off" />
                                    </div>
                                </div>

                                <div className="form-group1" style={{display:'none'}}>
                                    <label className="control-label">Time Out</label>
                                    <div>
                                        <input type="text" id="todate" name="todate" placeholder="MM/DD/YYYY" className="form-control date start" style={{width: '53%'}}  /> &nbsp;&nbsp;&nbsp;
                                        <input type="text" id="totime" name="totime" placeholder="00:00 AM/PM" className="form-control time start" style={{width: '42%'}}   autoComplete="off" />
                                    </div>
                                </div>
                            </div>


                             



                        </div>
                    </div>
            </form>
        );
    }
}

const ModelForm = reduxForm({
    form: 'model_form',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    updateUnregisteredFields: true,
    validate
})(modelForm);

class JobScheduleForm extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            //skills: []
        };

        var skillarray = [];
        const response = this.props.fields.skills;
        for (var k in response) {
            skillarray.push({label: response[k].name, value: response[k].id})
        }

        var peoplearray = [];
        const result = this.props.fields.peoples;
        for (var l in result) {
            peoplearray.push({label: result[l].firstName+' '+result[l].lastName, value: result[l].id})
        }
        this.props.fields.optionSkillList = skillarray;
        this.props.fields.optionPeopleList = peoplearray;
        //this.setState({loading: false});


    }

	componentDidMount() {
        let $this = this;
      
        $('#fromdate').datepicker({
            todayBtn: "linked",
            keyboardNavigation: false,
            forceParse: false,
            autoclose: true

        });

       $('#date-daily').datepicker({
            todayBtn: "linked",
            keyboardNavigation: false,
            forceParse: false,
            autoclose: true

        });

     

        $('#todate').datepicker({
            todayBtn: "linked",
            keyboardNavigation: false,
            forceParse: false,
            autoclose: true

        });

        $('#basicExample .time').timepicker({
            showDuration: true,
            template : false,
            showInputs : false,
            minuteStep : 5,
            timeFormat: 'g:i A'
        });

       
                     


        $.validator.setDefaults({
            ignore: []
        });
                $("#jobscheduleform").validate({
                    ignore: [],
			    	   		rules: {
			              //	  title:{required:true},
                            //  selectedSkill:{required:true},
                              fromdate:{required:true},
                              fromtime:{required:true},
                              todate:{required:true},
                              totime:{required:true}
                            //  selectedPeoples:{required:true}
                            //  team:{required:true},
                           //   equipment:{required:true}
			    	   		},
				    	   	messages: {
				    	   		 fromdate:"Please enter date and time",
                              fromtime:"Please enter date and time",
                              todate:"Please enter date and time",
                              totime:"Please enter date and time"
				    	   	},     
                    groups:{date:"fromdate fromtime todate totime"},
                    errorPlacement: function(error, element) {
                       if (element.attr("name") == "fromdate" || element.attr("name") == "fromtime" || element.attr("name") == "todate" || element.attr("name") == "totime") 
                        error.insertAfter("#basicExample");
                       else 
                          error.insertAfter(element);
                      }
		    	 });


                 
                  var rulesObj={}  
                      

	}

    componentWillMount(){
        
    }

    onRoleSelectChange(value) {
        const target = value;
        // console.log(target);
        if (!this.state.loading) {
            this.setState({rolename: target});
        }

    }


    render(){
    return (
        
           <div className="modal fade none-border bs-example-modal-md" id="add-new-event" data-keyboard="false" data-backdrop="static">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                           
<div className="card card-outline-info">



                            <div className="card-header">
                                <h4 className="m-b-0 text-white">Schedule form</h4>
                            </div>


                               {this.props.states.showMessage
                                ? <div className="alert alert-danger" style={{width:'100%'}}> <i className="fa fa-warning"></i> {this.props.states.messageText}
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">×</span> </button>
                                </div>
                                : ''
                              }
                            
  </div>
                            <div className="modal-body">

                                <Provider store={Store}>
                                    <ModelForm states={this.props.fields} initialValues={this.state}/>
                                </Provider>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary waves-effect waves-light save-category btn-rounded" id="saveevent">Add Calendar</button>
                                <button type="button" className="btn btn-white waves-effect btn-rounded" id="closeevent">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            

          );
  } 
}
export default JobScheduleForm;
